import { Component, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-content-wrapper',
    styleUrl: 'sew-ws-content-wrapper.scss',
    shadow: true,
})
export class SewWsContentWrapper {
    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;
    @Prop({ reflect: true }) limitContentWidth = false;
    @Prop({ reflect: true }) underlay = false;

    render() {
        return (
            <Host>
                <div class="underlay"></div>
                <div class="main-content-container">
                    <slot />
                </div>
            </Host>
        );
    }
}
